import React, { useEffect, useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import VirusBeaconClient from '../../../clients/VirusBeaconClient';
import useQuery from '../useQuery';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Alert from '@mui/material/Alert';

export default function ResultViewRadiomics() {
  const [numRx, setNumRx] = useState(null as number | null);
  const [loading, setLoading] = useState(false);
  const query = useQuery();

  const [message, setMessage] = useState(null);

  useEffect(() => {
    const abortController = new AbortController();
    (async () => {
      try {
        setNumRx(null);
        setLoading(true);
        const [existsIndividuals, numRx] =
          await VirusBeaconClient.getCountImage(query, abortController.signal);
        setLoading(false);
        setNumRx(numRx);
      } catch (error) {
        if (!abortController.signal.aborted) {
          // error!
          console.log('ERROR: ' + error);
          setLoading(false);
          setMessage('Problem with server.');
        }
      }
    })();
    return () => {
      abortController.abort();
    };
  }, [query, setNumRx]);

  return (
    <Box>
      <Box height="2em" />
      {loading && <CircularProgress />}
      {!loading && (
        <Alert severity="success">
          <Chip label="synthetic" size="small" /> Number of Rx: {numRx}
          {message && <>{message}</>}
        </Alert>
      )}
    </Box>
  );
}
